import { defineMessages } from 'react-intl';

const accountlinkConsentMessages = defineMessages({
  pageTitle: {
    id: 'accountLink.pageTitle',
    defaultMessage: 'Account link notification',
    description: 'The page title for account link notification.',
  },
  linkingInclusiveSingleAccountFirstLine: {
    id: 'accountLink.inclusive.singleAccount.firstLine',
    defaultMessage:
      'You already have an AWS Training & Certification profile with',
    description: 'Message for Inclusive Single account linking',
  },
  linkingMultiAccountFirstLine: {
    id: 'accountLink.multiAccount.firstLine',
    defaultMessage: 'You already have an AWS Training & Certification profile',
    description: 'First line for linking multiple accounts',
  },
  linkingExclusiveSignleAccount: {
    id: 'accountLink.exclusive.singleAccount',
    defaultMessage: `You already have an AWS Training & Certification profile with <b>{userEmail}</b> using <b>{currentProviderName}</b>. Transfer your profile to this new sign-in method so you can access your activity and data. You'll still be able to sign in using <b>{currentProviderName}</b>, but existing activity and data won't appear there. This transfer will also occur across other AWS Training & Certification products you've used.`,
    description: 'Message for exclusive single account linking',
  },
  linkingExclusiveSingleAccountFirstLine: {
    id: 'accountLink.exclusive.singleAccount.firstLine',
    defaultMessage:
      'You already have an AWS Training & Certification profile with',
    description: 'Message for Inclusive Single account linking',
  },
  linkingMultipleAccounts: {
    id: 'accountLink.multipleAccounts',
    defaultMessage: `You already have an AWS Training & Certification profile with <b>{userEmail}</b>. It was last accessed {lastUsedDate} using <b>{currentProviderName}</b>. Link this new sign-in to your profile so you can access your activity and data using either. This link will also occur across other AWS Training & Certification products you've used.`,
    description: 'Message to link multiple accounts',
  },
  confirmExistingProfileOwnershipToLinkHeader: {
    id: 'accountLink.confirmExistingProfileOwnershipToLink.header',
    defaultMessage: 'Validate with {currentProvider} to link',
    description: 'Confirm that you are the owner of the existing profile',
  },
  confirmExistingProfileOwnershipButton: {
    id: 'accountLink.confirmExistingProfileOwnership.button',
    defaultMessage: 'Validate with {currentProviderName}',
    description: 'Confirm that you are the owner of the existing profile',
  },
  confirmExistingProfileOwnershipInWrongPageButton: {
    id: 'accountLink.confirmExistingProfileOwnershipInWrongPageButton.button',
    defaultMessage: 'Validate with {currentProvider}',
    description: 'Confirm that you are the owner of the existing profile',
  },
  cantConfirmExistingProfileOwnershipButton: {
    id: 'accountLink.cantConfirmExistingProfileOwnership.button',
    defaultMessage: "I can't",
    description:
      'Cannot confirm that you are the owner of the existing profile',
  },
  confirmExistingProfileOwnershipMessage: {
    id: 'accountLink.confirmExistingProfileOwnership.message',
    defaultMessage:
      'Confirm that the existing profile belongs to you by signing in with <b>{currentProviderName}</b> using <b>{userEmail}</b>.',
    description: 'Confirm that you are the owner of the existing profile',
  },
  confirmExistingProfileOwnershipExclusiveMessage: {
    id: 'accountLink.confirmExistingProfileOwnershipExclusive.message',
    defaultMessage:
      'Confirm that the existing profile belongs to you by signing in to <b>{currentProviderName}</b> using <b>{userEmail}</b>.',
    description: 'Confirm that you are the owner of the existing profile',
  },
  areYouSureYouWantSkipLinkingHeader: {
    id: 'accountLink.areYouSureYouWantSkipLinking.header',
    defaultMessage: 'Are you sure?',
    description: 'Are you sure you want to skip linking',
  },
  goBackToLoginOptionsButton: {
    id: 'accountLink.goBackToLoginOptionsButton.button',
    defaultMessage: 'Go back',
    description: 'Go back to login options',
  },
  areYouSureYouWantSkipLinkingMessageInclusive: {
    id: 'accountLink.areYouSureYouWantSkipLinkingInclusive.message',
    defaultMessage:
      "This is a one time opportunity you'll have to link. If you can't link, you'll create new profile without your existing data and activity.",
    description: 'Are you sure you want to skip linking',
  },
  areYouSureYouWantSkipLinkingMessageExclusive: {
    id: 'accountLink.areYouSureYouWantSkipLinkingExclusive.message',
    defaultMessage:
      "This is a one time opportunity you'll have to transfer. If you can't transfer, you'll create new profile without your existing data and activity.",
    description: 'Are you sure you want to skip linking',
  },
  linkingNewSignInMethodLoadingMessage: {
    id: 'accountLink.linkingNewSignInMethodLoading.message',
    defaultMessage: 'Linking new sign-in method to your profile',
    description: 'Linking new sign-in method to your profile',
  },
  transferNewSignInMethodLoadingMessage: {
    id: 'accountLink.transferNewSignInMethodLoading.message',
    defaultMessage: 'Transfering your profile to this sign-in method',
    description: 'Transfering your profile to this sign-in method',
  },
  youHaveSignedInUsingTheWrongEmailHeader: {
    id: 'accountLink.youHaveSignedInUsingTheWrongEmail.header',
    defaultMessage: 'You have confirmed with the wrong email',
    description: 'You have signed in using the wrong email',
  },
  youHaveSignedInUsingTheWrongEmailMessage: {
    id: 'accountLink.youHaveSignedInUsingTheWrongEmail.message',
    defaultMessage: `It looks like you signed in to <b>{currentProviderName}</b> using <b>{validatedUserEmail}</b> but need to confirm profile ownership of <b>{originalUserEmail}</b> using <b>{currentProviderName}</b>.
      To try again:
      <ol>
      <li><signOutLink>Sign out</signOutLink> and return to this tab</li>
      <li>Confirm profile ownership using {currentProviderName}</li>
    </ol>`,
    description: 'You have signed in using the wrong email',
  },
  youHaveSignedInUsingTheWrongEmailMessageOtpProvider: {
    id: 'accountLink.youHaveSignedInUsingTheWrongEmailOtpProvide.message',
    defaultMessage: `It looks like you signed in to <b>{currentProviderName}</b> using <b>{validatedUserEmail}</b> but need to confirm profile ownership of <b>{originalUserEmail}</b> using <b>{currentProviderName}</b>.
      To try again:
      <ul>
      <li>Confirm profile ownership using {currentProviderName}</li>
    </ul>`,
    description: 'You have signed in using the wrong email',
  },
  youHaveSignedInUsingTheWrongEmailTryAgainMessage: {
    id: 'accountLink.youHaveSignedInUsingTheWrongEmail.tryAgainMessage',
    defaultMessage: 'To try again:',
    description: 'You have signed in using the wrong email',
  },
  confirmExistingProfileOwnershipToTransferHeader: {
    id: 'accountLink.confirmExistingProfileOwnershipToTransfer.header',
    defaultMessage: 'Validate with {currentProvider} to transfer',
    description: 'Confirm that you are the owner of the existing profile',
  },
  yesContinueWithNewProfileButton: {
    id: 'accountLink.yesContinueWithNewProfile.button',
    defaultMessage: 'Yes, continue with new profile',
    description: 'Yes, continue with new profile',
  },
  areYouSureYouWantSkipLinkingPageTitle: {
    id: 'accountLink.areYouSureYouWantSkipLinking.pageTitle',
    defaultMessage: 'Are you sure?',
    description: 'Are you sure you want to skip linking',
  },
  youHaveSignedInUsingTheWrongEmailPageTitle: {
    id: 'accountLink.youHaveSignedInUsingTheWrongEmail.pageTitle',
    defaultMessage: 'Validated Wrong Account',
    description: 'You have signed in using the wrong email',
  },
  header: {
    id: 'accountLink.profileLinking.header',
    defaultMessage: 'Profile linking',
    description: 'Account Linking Page header',
  },
});

export default accountlinkConsentMessages;
